/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HotelSummary } from './HotelSummary';
import {
    HotelSummaryFromJSON,
    HotelSummaryFromJSONTyped,
    HotelSummaryToJSON,
    HotelSummaryToJSONTyped,
} from './HotelSummary';
import type { PortfolioEarningsBreakdown } from './PortfolioEarningsBreakdown';
import {
    PortfolioEarningsBreakdownFromJSON,
    PortfolioEarningsBreakdownFromJSONTyped,
    PortfolioEarningsBreakdownToJSON,
    PortfolioEarningsBreakdownToJSONTyped,
} from './PortfolioEarningsBreakdown';
import type { PortfolioTransferOption } from './PortfolioTransferOption';
import {
    PortfolioTransferOptionFromJSON,
    PortfolioTransferOptionFromJSONTyped,
    PortfolioTransferOptionToJSON,
    PortfolioTransferOptionToJSONTyped,
} from './PortfolioTransferOption';

/**
 * 
 * @export
 * @interface ChainOption
 */
export interface ChainOption {
    /**
     * 
     * @type {string}
     * @memberof ChainOption
     */
    chainName: string;
    /**
     * 
     * @type {number}
     * @memberof ChainOption
     */
    chainStableId: number;
    /**
     * 
     * @type {HotelSummary}
     * @memberof ChainOption
     */
    hotelSummary?: HotelSummary;
    /**
     * 
     * @type {number}
     * @memberof ChainOption
     */
    pointsCost?: number;
    /**
     * 
     * @type {number}
     * @memberof ChainOption
     */
    cashCost?: number;
    /**
     * Cents per point
     * @type {number}
     * @memberof ChainOption
     */
    redemptionValue?: number;
    /**
     * 
     * @type {number}
     * @memberof ChainOption
     */
    redemptionPercentile?: number;
    /**
     * 
     * @type {number}
     * @memberof ChainOption
     */
    userPointsBalance?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ChainOption
     */
    canAffordWithPoints?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ChainOption
     */
    pointsShortfall?: number;
    /**
     * 
     * @type {Array<PortfolioTransferOption>}
     * @memberof ChainOption
     */
    transferOptions?: Array<PortfolioTransferOption>;
    /**
     * 
     * @type {PortfolioTransferOption}
     * @memberof ChainOption
     */
    bestTransferOption?: PortfolioTransferOption;
    /**
     * 
     * @type {PortfolioEarningsBreakdown}
     * @memberof ChainOption
     */
    earningsBreakdown?: PortfolioEarningsBreakdown;
    /**
     * 
     * @type {number}
     * @memberof ChainOption
     */
    portfolioScore: number;
    /**
     * 
     * @type {number}
     * @memberof ChainOption
     */
    rank: number;
    /**
     * 
     * @type {string}
     * @memberof ChainOption
     */
    recommendationLabel?: string;
}

/**
 * Check if a given object implements the ChainOption interface.
 */
export function instanceOfChainOption(value: object): value is ChainOption {
    if (!('chainName' in value) || value['chainName'] === undefined) return false;
    if (!('chainStableId' in value) || value['chainStableId'] === undefined) return false;
    if (!('portfolioScore' in value) || value['portfolioScore'] === undefined) return false;
    if (!('rank' in value) || value['rank'] === undefined) return false;
    return true;
}

export function ChainOptionFromJSON(json: any): ChainOption {
    return ChainOptionFromJSONTyped(json, false);
}

export function ChainOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChainOption {
    if (json == null) {
        return json;
    }
    return {
        
        'chainName': json['chain_name'],
        'chainStableId': json['chain_stable_id'],
        'hotelSummary': json['hotel_summary'] == null ? undefined : HotelSummaryFromJSON(json['hotel_summary']),
        'pointsCost': json['points_cost'] == null ? undefined : json['points_cost'],
        'cashCost': json['cash_cost'] == null ? undefined : json['cash_cost'],
        'redemptionValue': json['redemption_value'] == null ? undefined : json['redemption_value'],
        'redemptionPercentile': json['redemption_percentile'] == null ? undefined : json['redemption_percentile'],
        'userPointsBalance': json['user_points_balance'] == null ? undefined : json['user_points_balance'],
        'canAffordWithPoints': json['can_afford_with_points'] == null ? undefined : json['can_afford_with_points'],
        'pointsShortfall': json['points_shortfall'] == null ? undefined : json['points_shortfall'],
        'transferOptions': json['transfer_options'] == null ? undefined : ((json['transfer_options'] as Array<any>).map(PortfolioTransferOptionFromJSON)),
        'bestTransferOption': json['best_transfer_option'] == null ? undefined : PortfolioTransferOptionFromJSON(json['best_transfer_option']),
        'earningsBreakdown': json['earnings_breakdown'] == null ? undefined : PortfolioEarningsBreakdownFromJSON(json['earnings_breakdown']),
        'portfolioScore': json['portfolio_score'],
        'rank': json['rank'],
        'recommendationLabel': json['recommendation_label'] == null ? undefined : json['recommendation_label'],
    };
}

export function ChainOptionToJSON(json: any): ChainOption {
    return ChainOptionToJSONTyped(json, false);
}

export function ChainOptionToJSONTyped(value?: ChainOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'chain_name': value['chainName'],
        'chain_stable_id': value['chainStableId'],
        'hotel_summary': HotelSummaryToJSON(value['hotelSummary']),
        'points_cost': value['pointsCost'],
        'cash_cost': value['cashCost'],
        'redemption_value': value['redemptionValue'],
        'redemption_percentile': value['redemptionPercentile'],
        'user_points_balance': value['userPointsBalance'],
        'can_afford_with_points': value['canAffordWithPoints'],
        'points_shortfall': value['pointsShortfall'],
        'transfer_options': value['transferOptions'] == null ? undefined : ((value['transferOptions'] as Array<any>).map(PortfolioTransferOptionToJSON)),
        'best_transfer_option': PortfolioTransferOptionToJSON(value['bestTransferOption']),
        'earnings_breakdown': PortfolioEarningsBreakdownToJSON(value['earningsBreakdown']),
        'portfolio_score': value['portfolioScore'],
        'rank': value['rank'],
        'recommendation_label': value['recommendationLabel'],
    };
}

